module.exports = __webpack_public_path__ + "static/media/vertigo.df4987e7.png";